import PropTypes from "prop-types";

import { FormInput, FormRecordPicker, SectionCard } from "components/BaseForm";
import DepartmentService from "services/Department";

const fetchDepartments = search =>
  DepartmentService.getForFilters(search ? { search } : null);

/**
 * Name, title, and department. `children` lands in the same grid, so the create
 * form can place the entity picker beside the other fields.
 */
const DetailsSection = ({ departmentDisplay, children }) => (
  <SectionCard title="Details">
    <div className="tw:grid tw:grid-cols-1 tw:gap-5 tw:sm:grid-cols-2">
      <FormInput name="full_name" label="Full name" required />
      <FormInput name="preferred_name" label="Preferred name" />
      <FormInput name="title" label="Title" />
      {children}
      <FormRecordPicker
        name="department_id"
        label="Department"
        fetchOptions={fetchDepartments}
        onCreate={DepartmentService.createDepartment}
        placeholder="Search or create…"
        display={departmentDisplay}
      />
    </div>
  </SectionCard>
);

DetailsSection.propTypes = {
  departmentDisplay: PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.string,
  }),
  children: PropTypes.node,
};

export default DetailsSection;
